import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "table table-sm table-striped" }
const _hoisted_3 = { class: "border px-4 py-2" }
const _hoisted_4 = { class: "border px-4 py-2 space-x-2" }
const _hoisted_5 = { class: "d-flex gap-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { schedulePolicyService } from '@/services/backend/ApiService';
import { ListManager } from '@/services/manager/ListManager';
import ModalContent from '@/components/ModalContent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SchedulesList',
  setup(__props) {

const router = useRouter();
const listManager = new ListManager(schedulePolicyService);
const schedules = listManager.items;
const deletingPolicy = ref<any>(null);

const editPolicy = (policy: any) => {
  router.push(`/agendamentos/${policy.id}?mode=edit`);
};

const addPolicy = () => {
  listManager.add({});
};

const confirmDelete = (policy: any) => {
  deletingPolicy.value = policy;
};

const deletePolicy = async () => {
  if (deletingPolicy.value) {
    await listManager.remove(deletingPolicy.value.id);
    deletingPolicy.value = null;
  }
};

const cancelDelete = () => {
  deletingPolicy.value = null;
};

onMounted(() => listManager.fetchAll());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title bg-success" }, "Políticas de Horário", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "bg-gray-100 text-left" }, [
            _createElementVNode("th", { class: "border px-4 py-2" }, "Nome"),
            _createElementVNode("th", { class: "border px-4 py-2" }, "Ações")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schedules), (policy) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: policy.id
            }, [
              _createElementVNode("td", _hoisted_3, _toDisplayString(policy.name), 1),
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-primary me-2",
                    onClick: ($event: any) => (editPolicy(policy))
                  }, "Editar", 8, _hoisted_6),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-danger",
                    onClick: ($event: any) => (confirmDelete(policy))
                  }, "Excluir", 8, _hoisted_7)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: addPolicy
        }, "Adicionar")
      ]),
      _createVNode(ModalContent, {
        "is-modal-open": !!deletingPolicy.value,
        onClose: cancelDelete,
        onSend: deletePolicy,
        title: `Excluir Política`
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Você tem certeza que deseja excluir a política \"" + _toDisplayString(deletingPolicy.value?.name) + "\" ? ", 1)
        ]),
        _: 1
      }, 8, ["is-modal-open"])
    ])
  ], 64))
}
}

})